<template>

    <Head :title="nx_page.name">
        <meta
            type="title"
            :content="nx_page.seo_meta_title"
            head-key="title"
        >
        <meta
            type="description"
            :content="nx_page.seo_meta_description"
            head-key="description"
        >
        <meta
            type="keywords"
            :content="nx_page.seo_meta_keywords"
            head-key="keywords"
        >
    </Head>

    <div class="container-fluid distance-y-container"
         style="min-height: 100vh">
        <div class="row padding-y-0-100">
            <div class="col-12 col-lg-10 offset-lg-2">
                <h1 class="mb-5 ff-sans fw-500 fz-40 color-black lh-xs">Cookie policy</h1>
                <div v-html="nx_page.description"
                     class="site-content link-black ff-sans fw-400 fz-18 color-black lh-sm"></div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "Cookie",

    props: {
        nx_page: Object,
    }
}
</script>

<style scoped>

</style>
